import React from 'react'
import './index.css';

export const Project = (props) => {
    const redirectToLink = () => {
        window.location.href = props.link;
      };
    return (
        <div className="Project" onClick={redirectToLink}>
            <div className="Banner">
                <img src={props.img} alt="project-banner" />
            </div>
            <div className="type">
                {props.type} <span className='space' /> <b>{props.date}</b>
            </div>
            <div className="title">
                {props.title}
            </div>
            <div className="techstack">
                {props.techstack.map((tech, index) => (
                    <div key={index} className="separate">
                        <b>{tech}</b>
                    </div>
                ))}
            </div>
            <div className="details">
                {props.details}
            </div>
        </div>
    )
}
